import { toast } from '@heroui/react';

export function getErrorMessage(
  error: unknown,
  fallback = 'Ocorreu um erro inesperado.',
): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const msg = (error as { message: unknown }).message;
    if (typeof msg === 'string') return msg;
    if (Array.isArray(msg)) return msg.join(', ');
    if (msg != null) return String(msg);
  }
  return fallback;
}

function toastTitle(title: unknown, fallback: string): string {
  return typeof title === 'string' && title.trim() ? title : fallback;
}

export function showSuccess(message: string, title?: unknown) {
  toast.success(toastTitle(title, 'Sucesso'), { description: message });
}

export function showError(message: string, title?: unknown) {
  toast.danger(toastTitle(title, 'Erro'), { description: message });
}

export function showWarning(message: string, title?: unknown) {
  toast.warning(toastTitle(title, 'Atenção'), { description: message });
}

export function showInfo(message: string, title?: unknown) {
  toast.info(toastTitle(title, 'Aviso'), { description: message });
}

/**
 * Extra args (React Query `onError(error, variables, …)`) must not become the
 * toast title — an object title crashes React ("not a valid child") and blanks the app.
 */
export function showErrorFromUnknown(error: unknown, title?: unknown) {
  showError(getErrorMessage(error), title);
}
